import { render, staticRenderFns } from "./KeywordsList.vue?vue&type=template&id=0e597213&scoped=true"
import script from "./KeywordsList.vue?vue&type=script&lang=ts"
export * from "./KeywordsList.vue?vue&type=script&lang=ts"
import style0 from "./KeywordsList.vue?vue&type=style&index=0&id=0e597213&prod&scoped=true&lang=sass"
import style1 from "./KeywordsList.vue?vue&type=style&index=1&id=0e597213&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__ejs@3.1.1_da81010b62634e1624d752d96320e5d3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e597213",
  null
  
)

export default component.exports